"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAndSetAnonymousId = void 0;
var nanoid_1 = require("nanoid");
var js_cookie_1 = __importDefault(require("js-cookie"));
var ANONYMOUS_ID_COOKIE_NAME = 'juni_anonymous_id';
var COOKIE_EXPIRATION = 365; // 1 year
/**
 * Gets and sets the cross-domain anonymous ID. The anonymous ID is a
 * randomly generated string that is stored in a cross-domain cookie. This
 * function will always set the cookie to update the cookie expiration to
 * a year in advance.
 *
 * Note: If the domain is not a *.junilearning.com domain, it doesn't
 * specify a domain so will only be limited to that site
 *
 * @returns Cross-domain anonymous ID
 */
function getAndSetAnonymousId(forceNewToken) {
    if (forceNewToken === void 0) { forceNewToken = false; }
    // read anonymous ID cookie or generate new one
    var anonymousId = forceNewToken
        ? (0, nanoid_1.nanoid)()
        : js_cookie_1.default.get(ANONYMOUS_ID_COOKIE_NAME) || (0, nanoid_1.nanoid)();
    // check if we're on the junilearning.com domain
    var cookieDomain = window.location.href.includes('junilearning.com')
        ? 'junilearning.com'
        : undefined;
    js_cookie_1.default.set(ANONYMOUS_ID_COOKIE_NAME, anonymousId, {
        domain: cookieDomain,
        expires: COOKIE_EXPIRATION,
    });
    return anonymousId;
}
exports.getAndSetAnonymousId = getAndSetAnonymousId;
//# sourceMappingURL=anonymousId.js.map